// emailClassification.ts
export type EmailType = 'business' | 'free' | 'role' | 'disposable';

export const FREE_DOMAINS = [
  'gmail.com', 'yahoo.com', 'outlook.com', 'hotmail.com', 'aol.com',
  'icloud.com', 'live.com', 'msn.com', 'ymail.com', 'googlemail.com',
  'yahoo.co.uk', 'hotmail.co.uk', 'outlook.co.uk', 'gmail.co.uk',
  'protonmail.com', 'proton.me', 'tutanota.com', 'zoho.com',
  'mail.com', 'gmx.com', 'fastmail.com', 'me.com', 'mac.com',
  'rocketmail.com', 'yahoomail.com',
  // Regional Yahoo variants
  'yahoo.fr', 'yahoo.de', 'yahoo.es', 'yahoo.it', 'yahoo.ca',
  'yahoo.com.au', 'yahoo.co.in', 'yahoo.com.br', 'yahoo.com.mx', 'yahoo.co.jp'
];

export const ROLE_PREFIXES = [
  'info', 'sales', 'admin', 'support', 'contact', 'hello', 'team', 'office',
  'hr', 'jobs', 'careers', 'billing', 'accounts', 'help', 'service',
  'webmaster', 'postmaster', 'noreply', 'no-reply'
];

export const DISPOSABLE_DOMAINS = [
  'tempmail.com', 'throwaway.com', 'guerrillamail.com', 'mailinator.com',
  '10minutemail.com', 'temp-mail.org', 'fakeinbox.com', 'sharklasers.com',
  'guerrillamail.info', 'yopmail.com'
];

export function classifyEmail(email: string): EmailType {
  const domain = getEmailDomain(email);
  if (!domain) {
    return 'business';
  }

  const normalizedEmail = email.trim().toLowerCase();

  if (DISPOSABLE_DOMAINS.includes(domain)) {
    return 'disposable';
  }

  if (FREE_DOMAINS.includes(domain)) {
    return 'free';
  }

  const localPart = normalizedEmail.slice(0, normalizedEmail.lastIndexOf('@'));
  if (ROLE_PREFIXES.includes(localPart)) {
    return 'role';
  }

  return 'business';
}

export function isBusinessEmail(email: string): boolean {
  return classifyEmail(email) === 'business';
}

export function getEmailDomain(email: string): string {
  if (!email) {
    return '';
  }

  const trimmed = email.trim().toLowerCase();
  const atIndex = trimmed.lastIndexOf('@');

  if (atIndex <= 0 || atIndex === trimmed.length - 1) {
    return '';
  }

  return trimmed.slice(atIndex + 1);
}
